import { IExposableService } from '../../background/services/external-services-exposer.service';
import { PromotionDisplayDetails } from '../models/promotion-display-details.model';

// -----------------------------------------------------------------------------
export const kNameOfPromotionWindowService = 'PromotionWindowService';

// -----------------------------------------------------------------------------
export interface IPromotionWindowService extends IExposableService {
  getActivePromotion(): PromotionDisplayDetails;
  promotionBecameVisible();
  closePromotionWindow();
  getPromotionStopWatchTime();
  toggleTimeoutTimer(pause: boolean);
}
